import { render, staticRenderFns } from "./LoaderBtn.vue?vue&type=template&id=3e7f6265&scoped=true"
import script from "./index.ts?vue&type=script&lang=ts&external"
export * from "./index.ts?vue&type=script&lang=ts&external"
import style0 from "./LoaderBtn.vue?vue&type=style&index=0&id=3e7f6265&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7f6265",
  null
  
)

export default component.exports